import cx from 'classnames';
import React from 'react';

type TailwindSpacing =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 14
  | 16
  | 20
  | 24
  | 28
  | 32
  | 36
  | 40
  | 44
  | 48
  | 52
  | 56
  | 60
  | 64
  | 72
  | 80
  | 96;

interface DividerProps {
  className?: string;
  size?: TailwindSpacing;
}

const Divider: React.FC<DividerProps> = ({ className = '', size = 6 }) => (
  <hr className={cx(`yst-mb-${size} yst-mt-${size}`, className)} />
);

export default Divider;
